import { PhaseStepScheduleTypeBase } from './base/phase-step-schedule-type-base';

export class PhaseStepScheduleType extends PhaseStepScheduleTypeBase { }